import { render, staticRenderFns } from "./PhoneAdditionModal.vue?vue&type=template&id=917b5ff2&scoped=true&"
import script from "./PhoneAdditionModal.vue?vue&type=script&lang=js&"
export * from "./PhoneAdditionModal.vue?vue&type=script&lang=js&"
import style0 from "./PhoneAdditionModal.vue?vue&type=style&index=0&id=917b5ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917b5ff2",
  null
  
)

export default component.exports